import { ReactNode } from "react";
import { Box, Paper, Stack, Typography } from "@mui/material";
import { CARD_BORDER } from "../governanceStatus";
import { TEXT } from "./ui";

/**
 * Titled card used for the side column (Sign-off, Actions, Details, …) and
 * for the kind panels' sections in the main column.
 */
const SideCard = ({
  title,
  action,
  children,
  id,
}: {
  title: ReactNode;
  /** Right-aligned header content (a chip or a small button). */
  action?: ReactNode;
  children: ReactNode;
  id?: string;
}) => (
  <Paper id={id} elevation={0} sx={{ border: CARD_BORDER, borderRadius: "12px", p: 2, minWidth: 0 }}>
    <Stack
      direction="row"
      spacing={1}
      alignItems="center"
      justifyContent="space-between"
      useFlexGap
      sx={{ flexWrap: "wrap", mb: 1.5 }}
    >
      <Typography variant="subtitle2" component="h2" sx={{ fontWeight: 700, color: TEXT }}>
        {title}
      </Typography>
      {action ? <Box sx={{ display: "flex", alignItems: "center" }}>{action}</Box> : null}
    </Stack>
    {children}
  </Paper>
);

export default SideCard;
